import styled from 'styled-components';
import { Button } from '../Button';

const PageHeaderAction = styled(Button).attrs({ size: 'small' })``;

export default PageHeaderAction;
